module.exports = __webpack_public_path__ + "img/logo_kbank_smartpay.11687b6d.png";